(() => {
 if(customElements.get('shejtano-variant-picker'))return;
 class ShejtanoVariantPicker extends HTMLElement {
  connectedCallback(){
   if(this.controller)return;
   const select=this.querySelector('select');if(!select)return;
   this.select=select;this.controller=new AbortController();
   const signal=this.controller.signal,label=this.closest('.product-form__input')?.querySelector('label');
   this.button=document.createElement('button');this.button.type='button';
   this.button.className='shej-variant-trigger';this.button.id=select.id+'-trigger';
   this.button.setAttribute('aria-haspopup','listbox');this.button.setAttribute('aria-expanded','false');
   this.value=document.createElement('span');this.button.append(this.value);
   this.menu=document.createElement('div');this.menu.className='shej-variant-menu';
   this.menu.id=select.id+'-menu';this.menu.hidden=true;this.menu.setAttribute('role','listbox');
   this.menu.setAttribute('aria-label',label?.textContent.trim()||select.name);
   this.button.setAttribute('aria-controls',this.menu.id);
   if(typeof this.menu.showPopover==='function')this.menu.setAttribute('popover','manual');
   this.options=Array.from(select.options,(option,index)=>{
    const button=document.createElement('button');button.type='button';button.setAttribute('role','option');
    button.textContent=option.textContent.trim();button.disabled=option.disabled;
    button.addEventListener('click',()=>{
     if(select.disabled||option.disabled)return;
     const changed=select.selectedIndex!==index;option.selected=true;
     this.sync();this.close(true);
     if(changed)select.dispatchEvent(new Event('change',{bubbles:true}));
    },{signal});
    this.menu.append(button);return button;
   });
   document.body.append(this.menu);this.append(this.button);
   this.querySelector('.select').hidden=true;
   this.button.addEventListener('click',()=>this.opened?this.close():this.open(),{signal});
   label?.addEventListener('click',event=>{event.preventDefault();this.button.focus()},{signal});
   this.button.addEventListener('keydown',event=>{
    if(event.key==='ArrowDown'||event.key==='ArrowUp'){event.preventDefault();this.open(true)}
   },{signal});
   this.menu.addEventListener('keydown',event=>{
    const available=this.options.filter(button=>!button.disabled),index=available.indexOf(document.activeElement);
    if(event.key==='Escape'){event.preventDefault();this.close(true);return}
    if(event.key==='Tab'){this.close(true);return}
    let next;
    if(event.key==='ArrowDown')next=available[(index+1)%available.length];
    if(event.key==='ArrowUp')next=available[(index-1+available.length)%available.length];
    if(event.key==='Home')next=available[0];
    if(event.key==='End')next=available.at(-1);
    if(next){event.preventDefault();next.focus({preventScroll:true});this.reveal(next)}
   },{signal});
   document.addEventListener('pointerdown',event=>{
    if(this.opened&&!this.contains(event.target)&&!this.menu.contains(event.target))this.close();
   },{signal});
   document.addEventListener('keydown',event=>{if(this.opened&&event.key==='Escape'){event.preventDefault();this.close(true)}},{signal});
   window.addEventListener('resize',()=>this.position(),{signal});
   window.addEventListener('scroll',event=>{
    if(this.opened&&!this.menu.contains(event.target))this.position();
   },{capture:true,passive:true,signal});
   window.visualViewport?.addEventListener('resize',()=>this.position(),{signal});
   select.addEventListener('change',()=>this.sync(),{signal});
   this.observer=new MutationObserver(()=>this.sync());
   this.observer.observe(select,{attributes:true,attributeFilter:['disabled'],subtree:false});
   this.sync();
  }
  sync(){
   this.value.textContent=this.select.selectedOptions[0]?.textContent.trim()||'';
   this.button.disabled=this.select.disabled;
   this.options.forEach((button,index)=>button.setAttribute('aria-selected',String(index===this.select.selectedIndex)));
   if(this.select.disabled)this.close();
  }
  open(focus=false){
   if(this.select.disabled)return;
   document.querySelectorAll('shejtano-variant-picker').forEach(picker=>{if(picker!==this)picker.close?.()});
   this.menu.hidden=false;this.opened=true;this.button.setAttribute('aria-expanded','true');
   this.position();this.menu.showPopover?.();
   const selected=this.options[this.select.selectedIndex]||this.options[0];
   if(selected){this.reveal(selected);if(focus)selected.focus({preventScroll:true})}
  }
  position(){
   if(!this.opened)return;
   const rect=this.button.getBoundingClientRect(),viewport=window.visualViewport;
   const width=viewport?.width||innerWidth,height=viewport?.height||innerHeight;
   const x=viewport?.offsetLeft||0,y=viewport?.offsetTop||0;
   const below=y+height-rect.bottom-12,above=rect.top-y-12;
   const upwards=below<180&&above>below;
   const maxHeight=Math.max(48,Math.min(360,upwards?above:below));
   const menuWidth=Math.min(rect.width,width-24);
   this.menu.style.width=menuWidth+'px';this.menu.style.maxHeight=maxHeight+'px';
   this.menu.style.left=Math.max(x+12,Math.min(rect.left,x+width-menuWidth-12))+'px';
   this.menu.style.top=(upwards?Math.max(y+12,rect.top-Math.min(maxHeight,this.options.length*48+12)-8):rect.bottom+8)+'px';
  }
  reveal(button){
   const top=button.offsetTop,bottom=top+button.offsetHeight;
   if(top<this.menu.scrollTop)this.menu.scrollTop=top;
   else if(bottom>this.menu.scrollTop+this.menu.clientHeight)this.menu.scrollTop=bottom-this.menu.clientHeight;
  }
  close(focus=false){
   if(!this.menu)return;
   if(this.opened&&this.menu.hasAttribute('popover'))this.menu.hidePopover?.();
   this.menu.hidden=true;this.opened=false;this.button.setAttribute('aria-expanded','false');
   if(focus)this.button.focus({preventScroll:true});
  }
  disconnectedCallback(){
   this.close();this.controller?.abort();this.observer?.disconnect();this.menu?.remove();
   this.button?.remove();this.querySelector('.select')?.removeAttribute('hidden');this.controller=null;
  }
 }
 customElements.define('shejtano-variant-picker',ShejtanoVariantPicker);
})();
